import { render, staticRenderFns } from "./cvBio.vue?vue&type=template&id=61c30154"
import script from "./cvBio.vue?vue&type=script&lang=js"
export * from "./cvBio.vue?vue&type=script&lang=js"
import style0 from "./cvBio.vue?vue&type=style&index=0&id=61c30154&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports